var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import jsyaml from 'js-yaml';
import { NullYamlTransformer } from './YamlTransformer.js';
import { AsyncJsDatasetService } from './AsyncJsDatasetService.js';
export class AsyncYamlDatasetService extends AsyncJsDatasetService {
    constructor() {
        super();
    }
    static create(schemaFile, dataFiles = [], plugins = [], transformer = new NullYamlTransformer()) {
        return __awaiter(this, void 0, void 0, function* () {
            const datasetService = new AsyncYamlDatasetService();
            let loadedSchema = jsyaml.safeLoad(schemaFile);
            const data = dataFiles.map(dataFile => jsyaml.safeLoadAll(dataFile));
            yield datasetService.init(loadedSchema, data, plugins, transformer);
            return datasetService;
        });
    }
}
//# sourceMappingURL=AsyncYamlDatasetService.js.map